import PropTypes from "prop-types";
import InputPicture from "core/inputs/input-picture/InputPicture";
import { Typography } from "core/typography/Typography";
import PartyTextField from "./PartyTextField";

const LOGO_LABEL = { id: "input_logo_label", defaultMessage: "Logo" };

const PartyBlock = ({
  title,
  prefix,
  logoValue,
  onLogoChange,
  companyField,
  control,
  register,
  setCode,
  setStatus,
}) => (
  <div className="delivery-note-form__section">
    <Typography
      className="title-3 violet text-uppercase"
      type="h2"
      label={title}
    />
    <div className="delivery-note-party">
      <div className="corner-left">
        <InputPicture
          id={`delivery-note-${prefix}-logo`}
          label={LOGO_LABEL}
          value={logoValue}
          onChange={onLogoChange}
          setCode={setCode}
          setStatus={setStatus}
        />
      </div>
      <div className="center-block">
        <div className="cell-padding">{companyField}</div>
        <div className="cell-padding">
          <PartyTextField
            control={control}
            register={register}
            prefix={prefix}
            field="siret"
          />
        </div>
        <div className="cell-padding">
          <PartyTextField
            control={control}
            register={register}
            prefix={prefix}
            field="phone"
          />
        </div>
      </div>
      <div className="corner-right">
        <PartyTextField
          control={control}
          register={register}
          prefix={prefix}
          field="address"
          rows={3}
        />
      </div>
    </div>
  </div>
);

PartyBlock.propTypes = {
  title: PropTypes.node.isRequired,
  prefix: PropTypes.oneOf(["issuer", "recipient"]).isRequired,
  logoValue: PropTypes.string,
  onLogoChange: PropTypes.func.isRequired,
  companyField: PropTypes.node.isRequired,
  control: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  setCode: PropTypes.func,
  setStatus: PropTypes.func,
};

export default PartyBlock;
